import { render, staticRenderFns } from "./ProductReject.vue?vue&type=template&id=b2142b04&scoped=true"
import script from "./ProductReject.vue?vue&type=script&lang=js"
export * from "./ProductReject.vue?vue&type=script&lang=js"
import style0 from "./ProductReject.vue?vue&type=style&index=0&id=b2142b04&prod&scoped=true&lang=scss"
import style1 from "./ProductReject.vue?vue&type=style&index=1&id=b2142b04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2142b04",
  null
  
)

export default component.exports